import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./index.css"
import "@/assets/css/rtc-content.css"
import axios from 'axios'
import VueAxios from 'vue-axios'
// import 'video.js/dist/video-js.css';
// import './assets/css/main.css'
// import Echo from "laravel-echo"
// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: "75b8f88005eb567db2c7",
//     wsHost:"127.0.0.1",
//     wsPort: 6001,
//     cluster: "mt1",
//     forceTLS: false,
//     disableStats: true,
//     authEndpoint :'http://127.0.0.1:8000/api/broadcasting/auth',
//     auth:{
//         headers: {
//             Authorization: `Bearer ${localStorage.getItem('Token')}`, 
//         }
//     },
 
// });

createApp(App).use(store).use(router).use(VueAxios, axios).mount('#app')
